import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { copyQuizset } from '@/api/gen/quiz/quiz.gen';

/**
 * 퀴즈를 내 퀴즈로 즉시 복사한다 (`POST /quizsets/{sourceQuizsetId}/copy`). 복사와 폴더 배정이 한 요청이다.
 *
 * `folderId` 를 생략하면 폴더 없는 기본 내 퀴즈 자리에 저장된다.
 * 응답의 `id` 가 새 퀴즈 ID 다 — 원본 ID 로 상세 이동·캐시 갱신을 하면 안 된다.
 * 잠금 여부도 응답의 `isLocked` 를 쓴다.
 *
 * 복사본은 서버가 항상 공개로 만든다. 요청 필드는 `folderId` 뿐이다.
 */
export const copyQuizToLocation = async ({
  sourceQuizsetId,
  folderId,
}: {
  sourceQuizsetId: string;
  folderId?: string;
}): Promise<QuizSetDetailsRes> =>
  (await copyQuizset(sourceQuizsetId, { folderId })).data;
